<template>
    <b-modal
        id="personal-internship-modal"
        v-model="modal"
        modal-class="apprentice-default-modal internship-detail-modal"
        ref="personal-internship-modal"
        size="lg"
        :title="internship.internship_ownerable.full_name"
        :ok-title="$t('internship.accept')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onOk">
        <h3 class="title">{{ internship.name }}</h3>
        <div class="description">
            {{ internship.description }}
        </div>
        <div class="gg-map-location">
            {{ internship.location }}
            <!--            <img src="/images/default-google-map.png" alt="Google maps locatie">-->
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-internships-personal-modal-component',
    data() {
        return {
            internship: null,
            modal: false,
        };
    },
    methods: {
        onOk() {
            let data = {
                internship_id: this.internship.id,
            };

            axios.post(this.routes.internshipAcceptPersonal(), data).then(
                (response) => {
                    this.$emit('accepted', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        show(internship) {
            this.modal = true;
            this.internship = internship;
        },
    },
};
</script>

<style scoped></style>
